module.exports = __webpack_public_path__ + "affe28740bdcda4e5774d31859821d9e.png";